import { create } from 'zustand';

export type AuthDialogTab = 'login' | 'register';

interface SetAuthDialogOptions {
  initialTab?: AuthDialogTab;
}

interface ModalStore {
  isOpenAuthDialog: boolean;
  authDialogMessage: string | null;
  authDialogInitialTab: AuthDialogTab;
  setIsOpenAuthDialog: (
    isOpen: boolean,
    message?: string | null,
    options?: SetAuthDialogOptions,
  ) => void;
  setAuthDialogMessage: (message: string | null) => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  isOpenAuthDialog: false,
  authDialogMessage: null,
  authDialogInitialTab: 'login',
  setIsOpenAuthDialog: (isOpen, message = null, options) =>
    set({
      isOpenAuthDialog: isOpen,
      authDialogMessage: isOpen ? message : null,
      authDialogInitialTab: isOpen ? (options?.initialTab ?? 'login') : 'login',
    }),
  setAuthDialogMessage: (message) => set({ authDialogMessage: message }),
}));
